export const API_URL = 'https://jumia.youmingtechnologies.co.ke'; // Use https:// if your server supports HTTPS

